<template>
  <div>
    <el-table :data="tableServerInfo" border :row-class-name="tableRowClassName">
      <el-table-column prop="ids" :label="$t('app.cardDetail.cardJftc.serialNumber')" align="center" width="60px"></el-table-column>
      <el-table-column prop="orderNum" :label="$t('app.cardDetail.cardJftc.orderNumber')" align="center" width="220">
        <template slot-scope="{row}">
          <div> {{ row.orderNum || '-' }}</div>
          <div  style="color: #8c8c8c;"> {{ row.thirdOrderId || '' }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="productName" :label="$t('app.cardDetail.cardJftc.packageName')" align="center" width="220"></el-table-column>
      <el-table-column prop="useFlowjia" :label="$t('app.cardDetail.cardJftc.usedFlow')" align="center" v-if="!adminShow"></el-table-column>
      <el-table-column prop="useFlow" :label="$t('app.cardDetail.cardJftc.usedFlow')" align="center" v-if="adminShow" width="120"></el-table-column>
      <el-table-column prop="monthFlow" :label="$t('app.cardDetail.cardJftc.totalFlow')" align="center" ></el-table-column>
      <el-table-column prop="status" v-if="adminShow" :label="$t('app.cardDetail.cardJftc.packageStatus')" align="center" >
        <template slot-scope="scope">
          <span v-if="scope.row.status == '未使用'" style="color: #1890ff;">{{ $t('app.cardDetail.cardJftc.status.unused') }}</span>
          <span v-else-if="scope.row.status == '使用中'" style="color: #52c41a;">{{ $t('app.cardDetail.cardJftc.status.inUse') }}</span>
          <span v-else-if="scope.row.status == '已使用'" style="color: #8c8c8c;">{{ $t('app.cardDetail.cardJftc.status.used')  }}</span>
          <span v-else-if="scope.row.status == '已过期'" style="color: #8c8c8c;">{{ $t('app.cardDetail.cardJftc.status.expired') }}</span>
          <span v-else-if="scope.row.status == '已转移'" style="color: #722ed1;">{{ $t('app.cardDetail.cardJftc.status.transferred')}}</span>
          <span v-else-if="scope.row.status == '已作废'" style="color: #f5222d;">{{ $t('app.cardDetail.cardJftc.status.invalid') }}</span>
          <span v-else>{{ scope.row.status }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" v-if="!adminShow" :label="$t('app.cardDetail.cardJftc.packageStatus')" align="center" >
        <template slot-scope="scope">
          <span v-if="scope.row.status == '未使用'" >{{ $t('app.cardDetail.cardJftc.status.unused') }}</span>
          <span v-else-if="scope.row.status == '使用中'" >{{ $t('app.cardDetail.cardJftc.status.inUse') }}</span>
          <span v-else-if="scope.row.status == '已使用'" >{{ $t('app.cardDetail.cardJftc.status.used')  }}</span>
          <span v-else-if="scope.row.status == '已过期'" >{{ $t('app.cardDetail.cardJftc.status.expired') }}</span>
          <span v-else-if="scope.row.status == '已转移'" >{{ $t('app.cardDetail.cardJftc.status.transferred')}}</span>
          <span v-else-if="scope.row.status == '已作废'" >{{ $t('app.cardDetail.cardJftc.status.invalid') }}</span>
          <span v-else>{{ scope.row.status }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="startTime" :label="$t('app.cardDetail.cardJftc.startTime')" align="center" width="220"></el-table-column>
      <el-table-column prop="endTime" :label="$t('app.cardDetail.cardJftc.endTime')" align="center" width="220"></el-table-column>

      <el-table-column prop="internationalSourceKey" v-if="adminShow && channel == 'multi'" :label="$t('app.internationalCardInfo.cardProduct.resourceCode')" align="center" width="180" :show-overflow-tooltip="true" ></el-table-column>
      <el-table-column prop="interfaceStatus" align="center" width="120" v-if="adminShow && channel != 'cmBrazil'">
        <span  slot="header">
              <el-tooltip :content="$t('app.internationalCardInfo.cardProduct.tooltip.generatePackage')" placement="top">
                  <i class="el-icon-question"></i>
              </el-tooltip>
                {{ $t('app.internationalCardInfo.cardProduct.generatePackage') }}
          </span>
        <template slot-scope="{row}">
            <el-tag v-if="row.interfaceStatus =='1'">{{ $t('app.internationalCardInfo.cardProduct.status.notGenerated') }}</el-tag>
            <el-tag v-else-if="row.interfaceStatus =='2'" type="success">{{ $t('app.internationalCardInfo.cardProduct.status.generated') }}</el-tag>
            <el-tag v-else-if="row.interfaceStatus =='3'" type="info">{{ $t('app.internationalCardInfo.cardProduct.status.invalidated') }}</el-tag>
            <el-tag v-else-if="row.interfaceStatus =='4'" type="danger">{{ $t('app.internationalCardInfo.cardProduct.status.failed') }}</el-tag>
            <el-tag v-else type="warning">{{ $t('app.internationalCardInfo.cardProduct.status.unknown') }}</el-tag>
          </template>
      </el-table-column>
      <el-table-column prop="operatorDataStatus" align="center" width="140" v-if="adminShow && channel != 'cmBrazil'">
        <span  slot="header">
              <el-tooltip :content="$t('app.internationalCardInfo.cardProduct.tooltip.operatorPackageStatus')" placement="top">
                  <i class="el-icon-question"></i>
              </el-tooltip>
                {{ $t('app.internationalCardInfo.cardProduct.operatorPackageStatus') }}
          </span>
        <template slot-scope="{row}">
          <el-tag>{{row.operatorDataStatus}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="activeTime" :label="$t('app.internationalCardInfo.cardProduct.operatorActiveExpireTime')" align="center" width="220" v-if="adminShow && channel != 'cmBrazil'">
        <template slot-scope="{row}">
          <div> {{ row.activeTime || '-' }}</div>
          <div  style="color: #8c8c8c;"> {{ row.dataExpireDate || '-' }}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="dataExpireDate" :label="$t('app.internationalCardInfo.cardProduct.operatorFlowUsage')" align="center" width="220" v-if="adminShow && channel != 'cmBrazil'">
        <template slot-scope="{row}">
          <div> {{ row.operatorTotalFlow || '-' }}</div>
          <div  style="color: #8c8c8c;"> {{ row.operatorUseFlow || '-' }}</div>
        </template>
      </el-table-column> -->
      
      <el-table-column prop="countries" :label="$t('app.internationalCardInfo.cardProduct.restrictedArea')" align="center" width="220" v-if="adminShow">
        <template slot-scope="{row}">
          <div class="product-list" v-if="row.countries && row.countries.length > 0">
            <div class="product-item" v-for="(item,index) in row.countries.slice(0, 1)" :key="index" :title="item">
                  <span>{{item}}</span>
            </div>
            <span class="el-dropdown-link" v-if="row.countries.length>1" @click="showMoreCountry(row)">
              <i class="el-icon-d-arrow-right el-icon--right"></i>{{$t('app.common.more')}}
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="200" v-if="adminShow">
        <template slot-scope="scope">
          <el-button size="mini" type="danger" v-if='!scope.row.startTime && scope.row.status !== "已转移"' @click="activatepackage(scope.row.orderNum)" style="background:#24D2B5;border: 1px solid #24D2B5;width:72px" v-hasPermi="['inter:active:flow']">激活套餐</el-button>
        </template>
      </el-table-column>
      
    </el-table>
    <el-dialog title="国家列表" :visible.sync="moreCountryOpen" width="700px" append-to-body :close-on-click-modal="false">
      <el-input v-model="searchCountry" placeholder="搜索国家" clearable style="margin-bottom: 15px;"></el-input>
      <el-tag
        v-for="(country, index) in filteredCountries"
        :key="index"
        effect="plain"
        style="margin: 4px"
      >
        {{ country }}
      </el-tag>
    </el-dialog>
  </div>
</template>
<script>
import { cardProduct } from "@/api/api.js"; //资费列表
import { mannualActiveFlow } from "@/api/international.js";
export default {
  props: {
    iccid: {
      type: [String]
    },
    channel: {
      type: [String]
    },

  },
  data() {
    return{
      tableServerInfo:[],
      moreCountryOpen:false,
      moreCountryData:[],
      searchCountry:""
    }
  },
  computed: {
    adminShow(){
      return this.$store.getters.user.userType =='1'
    },
    filteredCountries() {
      if (!this.searchCountry) {
        return this.moreCountryData;
      }
      const searchTerm = this.searchCountry.toLowerCase();
      return this.moreCountryData.filter(country => 
        country.toLowerCase().includes(searchTerm)
      );
    }
  },
  watch: {
    iccid() {
      this.initData();
    }
  },
  methods: {
    tableRowClassName({ row }) {
      // 当状态为"使用中"时，返回高亮类名
      if (row.status === "使用中") {
        return "highlight-row";
      }
      return "";
    },
    Packagestatus(status) {
      let obj = {
        1: "未使用",
        2: "使用中",
        3: "已使用",
        4: "已过期",
        5: "已转移",
        6: "已作废",
      };
      return obj[status];
    },
    // 截取小数点的方法
    formatDecimal(num, decimal) {
      num = num.toString()
      let index = num.indexOf('.')
      if (index !== -1) {
          num = num.substring(0, decimal + index + 1)
      } else {
          num = num.substring(0)
      }
      return parseFloat(num).toFixed(decimal)
    },

    // 获取列表的数据
    initData(){
      if(!this.iccid || this.iccid == ''){
        return;
      }
      let params = {
        iccid : this.iccid
      };
      cardProduct(params).then(res => {
        if(res.data.code == 200){
          this.tableServerInfo = res.data.data;
          this.tableServerInfo.map((item,index)=>{
            item.ids = index + 1;
            item.status = this.Packagestatus(item.status);
            if(this.adminShow){
              if(item.monthFlow < 0){
                item.monthFlow = "畅享";
              }else{
                item.monthFlow = this.formatDecimal(item.monthFlow,2);
              }
              item.useFlow = this.formatDecimal(item.useFlow,2);
            }else{
              item.monthFlow = this.formatDecimal(item.monthFlow,2);
              if(item.monthFlow < 0){
                item.monthFlow = "畅享";
                item.useFlow = "畅享";
              }else{
                item.useFlow = this.formatDecimal(item.useFlow,2);
              };
              if(item.status == "已过期"){
                item.useFlowjia = item.monthFlow;
              }else{
                item.useFlowjia = item.useFlow;
              }
            }
          })
        }
      })
    },
    // 激活套餐
    activatepackage(row){
      this.$confirm('是否继续激活套餐?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          orderNum:row,
          iccid : this.iccid
        }
        mannualActiveFlow(params).then(res => {
          if (res.data.code == 200){
            this.initData();
            this.$message({
              type: 'success',
              message: '激活成功!'
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消激活'
        });          
      });
    },
    showMoreCountry(row){
      this.moreCountryOpen = true
      this.searchCountry = '';
      this.moreCountryData = [];
      this.$nextTick(() => {
        // 使用展开运算符创建新数组
        this.moreCountryData = [...row.countries]; 
      });
    }
  },
  created() {
   this.initData();
  }
};
</script>

<style scoped lang="less">
::v-deep .highlight-row {
  background-color: #f0f9eb !important; /* 浅绿色背景 */
}
.product-list{
  display: flex; /* 或者 inline-flex */
  flex-wrap: wrap; /* 允许元素在需要时换行 */
  width: 160px;
  color: #409eff;
  .product-item{
    border: 1px solid #dcdfe6;
    width: 80px; /* 设置子元素的宽度 */
    white-space: nowrap;
    overflow: hidden; /* 隐藏超出容器的文本 */
    text-overflow: ellipsis; /* 使用省略号表示文本被截断 */
    height: 30px; /* 设置子元素的高度 */
    margin: 5px; /* 设置子元素的外边距 */
    background: #ecf5ff; /* 设置背景颜色 */
    line-height: 30px;
    align-content: flex-start;
    border-color: #b3d8ff;
    border-radius: 6px;
  }
  .el-dropdown-link{
    cursor: pointer;
    color: #409EFF;
    margin-left: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 30px;
    margin: 5px;
    line-height: 30px;
    -ms-flex-line-pack: start;
    align-content: flex-start;

  }
}
</style>


